import React from 'react';
import Loader from '../UI/Loader/Loader';
import { Formik, Form } from 'formik';
import { TargetExperienceSchema } from '../../schemas';
import PrimaryModal from '../UI/Modal/PrimaryModal';
import { FormikInput, PrimaryButton } from "../UI";

const CreateExperienceModal = ({ setShowCreateExperienceModal, experienceSuccessMessage, loading, handleSubmit, error }) => {
  return (
    <PrimaryModal title="Create Experience" hideModal={setShowCreateExperienceModal}>
        <div className='p-6 space-y-6'>
            {loading && <Loader />}
            { experienceSuccessMessage && <div>
                <p className='text-center'>{ experienceSuccessMessage }</p>
            </div> }
            { !experienceSuccessMessage && <div>
                <Formik
                    initialValues={{
                        experience_name: ''
                    }}
                    validationSchema={TargetExperienceSchema}
                    onSubmit={handleSubmit}
                >
                    {() => (
                        <Form className="space-y-4 md:space-y-6" action="#" id="target-form">
                            <FormikInput
                                type="text"
                                id="experience_name"
                                name="experience_name"
                                label="Enter Experience name"
                                mandatory
                            />
                            {error && <p className="text-base leading-tight tracking-tight text-red-500 mb-4">{error}</p>}
                            <div className="flex items-center justify-end space-x-2">
                                <PrimaryButton type="submit">Submit</PrimaryButton>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div> }
        </div>
    </PrimaryModal>
  )
}

export default CreateExperienceModal;